var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendanceBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27018",
    "data-name": "Group 27018",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 43.497,
    viewBox: "0 0 51 43.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27017",
    "data-name": "Group 27017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10615",
    "data-name": "Path 10615",
    d: "M272.414,336.332a7.1,7.1,0,0,1,.178-3.9,7.3,7.3,0,0,1,3.776-4.229,6.887,6.887,0,0,1,4.291-.621.589.589,0,0,0,.674-.594V310.719a2.393,2.393,0,0,0-2.393-2.393h-32.31a2.393,2.393,0,0,0-2.393,2.393v16.246a.591.591,0,0,0,.674.59,6.943,6.943,0,0,1,5.06,1.233,7.053,7.053,0,0,1,3,7.541.59.59,0,0,0,.583.717h1.556a.6.6,0,0,0,.576-.469,7.213,7.213,0,0,1,14.018,0,.6.6,0,0,0,.576.469h1.556A.59.59,0,0,0,272.414,336.332ZM268.522,323l-7.234,4.43a1.769,1.769,0,0,1-2.693-1.508v-8.861a1.769,1.769,0,0,1,2.693-1.508l7.234,4.431A1.768,1.768,0,0,1,268.522,323Zm-22.585,16.531a4.829,4.829,0,1,0-4.829-4.829A4.829,4.829,0,0,0,245.937,339.528Zm28.678-4.829a4.829,4.829,0,1,0,4.829-4.829A4.829,4.829,0,0,0,274.616,334.7Zm9.638,7.264h-9.619a3.922,3.922,0,0,0-3.3,1.8.618.618,0,0,0,.134.822,6.322,6.322,0,0,1,2.121,3.194.6.6,0,0,0,.574.452h12.828a1.2,1.2,0,0,0,1.2-1.2V345.9A3.937,3.937,0,0,0,284.254,341.963Zm-33.507,0h-9.619a3.937,3.937,0,0,0-3.937,3.937v1.136a1.2,1.2,0,0,0,1.2,1.2h12.828a.6.6,0,0,0,.574-.452,6.322,6.322,0,0,1,2.121-3.194.617.617,0,0,0,.134-.822A3.923,3.923,0,0,0,250.747,341.963Z",
    transform: "translate(-237.191 -308.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10616",
    "data-name": "Path 10616",
    d: "M259.938,338.987a4.829,4.829,0,1,0-4.829-4.829A4.829,4.829,0,0,0,259.938,338.987Zm4.809,2.435h-9.619a3.937,3.937,0,0,0-3.937,3.937V346.5a1.2,1.2,0,0,0,1.2,1.2h15.1a1.2,1.2,0,0,0,1.2-1.2v-1.136A3.937,3.937,0,0,0,264.747,341.422Z",
    transform: "translate(-234.438 -304.195)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceBox);
export default __webpack_public_path__ + "static/media/attendanceBox.d19a7edf21b6b6b93756240a56d106f2.svg";
export { ForwardRef as ReactComponent };